import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as Actions from './actions';
import * as Constants from './constants';

const Inquiries = Record({
    activeTab: Constants.TAB_NAMES.ABOUT,
    editActionId: null,
    isVisible: false,
    websiteFormModalIsVisible: false,
    fetchingInquirySignupLink: false,
    inquirySignupLink: undefined,
    newInquiryIsVisible: false,
    showStartIn: false,
    savingStartsIn: false,
    institutionId: '',
    updatingInquiry: false,
    deletingInquiry: false,
    creatingInquiry: false,
    inquiryId: '',
    showNewActionForm: false,
    deletingAction: false,
    savingAction: false,
});

export default handleActions(
    {
        [Actions.selectTab.type]: (state, {payload}) =>
            state.merge({
                activeTab: payload.tab,
            }),
        [Actions.showStartIn.type]: (state, {payload}) =>
            state.merge({
                showStartIn: payload.show,
            }),
        [Actions.editInquiryAction.type]: (state, {payload}) =>
            state.merge({
                editActionId: payload.inquiryActionId,
            }),
        [Actions.createInquiry.type]: state =>
            state.merge({
                creatingInquiry: true,
            }),
        [Actions.createInquirySuccess.type]: () => new Inquiries(),
        [Actions.createInquiryFailed.type]: state =>
            state.merge({
                creatingInquiry: false,
            }),
        [Actions.startIn.type]: state =>
            state.merge({
                savingStartsIn: true,
            }),
        [Actions.startInSuccess.type]: () => new Inquiries(),
        [Actions.startInFailed.type]: state =>
            state.merge({
                savingStartsIn: false,
            }),
        [Actions.updateInquiry.type]: state =>
            state.merge({
                updatingInquiry: true,
            }),
        [Actions.updateInquirySuccess.type]: state =>
            state.merge({
                updatingInquiry: false,
            }),
        [Actions.updateInquiryFailed.type]: state =>
            state.merge({
                updatingInquiry: false,
            }),
        [Actions.deleteInquiry.type]: state =>
            state.merge({
                deletingInquiry: true,
            }),
        [Actions.deleteInquirySuccess.type]: () => new Inquiries(),
        [Actions.deleteInquiryAborted.type]: state =>
            state.merge({
                deletingInquiry: false,
            }),
        [Actions.deleteInquiryFailed.type]: state =>
            state.merge({
                deletingInquiry: false,
            }),
        [Actions.showInquiryModal.type]: (state, {payload}) =>
            new Inquiries({
                isVisible: payload.showModal,
                institutionId: payload.institutionId,
                inquiryId: payload.inquiryId,
            }),
        [Actions.closeInquiryModals.type]: () => new Inquiries(),
        [Actions.showWebsiteFormModal.type]: (state, {payload}) =>
            new Inquiries({
                institutionId: payload.institutionId,
                websiteFormModalIsVisible: payload.showModal,
            }),

        [Actions.fetchInquirySignupLink.type]: state =>
            state.merge({
                fetchingInquirySignupLink: true,
            }),
        [Actions.fetchInquirySignupLinkSuccess.type]: (state, {payload}) =>
            state.merge({
                fetchingInquirySignupLink: false,
                inquirySignupLink: payload.link,
            }),
        [Actions.showNewActionForm.type]: (state, {payload}) =>
            state.merge({
                showNewActionForm: payload.show,
            }),
        [Actions.updateInquiryActionSuccess.type]: state =>
            state.merge({
                savingAction: false,
                editActionId: null,
            }),
        [Actions.updateInquiryActionFailed.type]: state =>
            state.merge({
                savingAction: false,
            }),
        [Actions.deleteInquiryActionSuccess.type]: state =>
            state.merge({
                deletingAction: false,
                editActionId: null,
            }),
        [Actions.deleteInquiryActionFailed.type]: state =>
            state.merge({
                deletingAction: false,
            }),
        [Actions.deleteInquiryActionAborted.type]: state =>
            state.merge({
                deletingAction: false,
            }),
        [Actions.createInquiryAction.type]: state =>
            state.merge({
                savingAction: true,
            }),
        [Actions.createInquiryActionSuccess.type]: state =>
            state.merge({
                savingAction: false,
                showNewActionForm: false,
            }),
        [Actions.createInquiryActionFailed.type]: state =>
            state.merge({
                savingAction: false,
            }),
    },
    new Inquiries(),
);
